import { getGridStringOperators } from '@mui/x-data-grid-premium'

const isAnyOfOperator = getGridStringOperators().find(op => op.value === 'isAnyOf')

export const customNotAnyOfOperator = {
  ...isAnyOfOperator,
  label: 'is not any of',
  value: 'notAnyOf',
  getApplyFilterFn: filterItem => {
    if (!filterItem.value || filterItem.value.length === 0) {
      return null
    }

    return cellValue => {
      // Instead of checking if included, check if NOT included
      return !filterItem.value.includes(cellValue)
    }
  },
}
